export default "__VITE_ASSET__BBoV8dk5__"